import React from 'react';
import styled from 'styled-components';

const B7Style = styled.svg``;

export const B7 = ({ color }) => {
	return (
		<B7Style
			xmlns='http://www.w3.org/2000/svg'
			width='22.197'
			height='22.336'
			viewBox='0 0 22.197 22.336'
		>
			<path
				id='Film'
				d='M942.526,413.274a.516.516,0,0,1,0-1.033h6.368a.516.516,0,0,1,0,1.033Zm10.937-.461,2.71-1.987a.856.856,0,0,1,1.368.686h0v5.858a.859.859,0,0,1-1.4.656l-2.675-1.956v.722a2.9,2.9,0,0,1-2.886,2.886h-.747l2.515,2.511a.857.857,0,0,1-1.214,1.209l-3.719-3.719h-.844v3.111a.857.857,0,1,1-1.714,0v-3.111h-.844l-3.719,3.719a.863.863,0,0,1-1.216,0,.854.854,0,0,1,0-1.209l2.509-2.511h-.747a2.911,2.911,0,0,1-2.042-.85l-.037-.05a2.846,2.846,0,0,1-.8-1.987V411.67a5.611,5.611,0,0,1,3-10.354,5.638,5.638,0,0,1,4.752,2.638,5.611,5.611,0,1,1,7.752,7.716v1.143Zm2.364.389-1.695,1.239,1.695,1.239V413.2Zm-9.26-6.271a.854.854,0,0,1-1.708,0,3.9,3.9,0,1,0-7.231,2.042,3.965,3.965,0,0,0,1.556,1.434.853.853,0,0,1,.486.826l-.007.091.007,5.468a1.159,1.159,0,0,0,.309.8l.031.029a1.172,1.172,0,0,0,.826.346h9.74a1.183,1.183,0,0,0,1.173-1.172v-5.42c0-.019-.007-.128-.007-.128a.853.853,0,0,1,.469-.826,3.9,3.9,0,1,0-5.644-3.488Zm3.262-.637a.9.9,0,1,0,1.276,0,.907.907,0,0,0-1.276,0Zm-.724-.729a1.929,1.929,0,1,1,0,2.728,1.941,1.941,0,0,1,0-2.728Zm-8.785.729a.9.9,0,0,0,1.269,1.27.894.894,0,0,0,0-1.27.9.9,0,0,0-1.269,0Zm-.724-.729a1.927,1.927,0,1,1,0,2.728,1.933,1.933,0,0,1,0-2.728Zm2.928,11.041a.511.511,0,0,1,0-1.021h6.368a.511.511,0,1,1,0,1.021Z'
				transform='translate(-935.344 -401.317)'
				fill={color}
			/>
		</B7Style>
	);
};
